// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"8":"packages","345":"portfolio","353":"contact","543":"gallery","594":"about","609":"faq"}[chunkId] + "." + {"8":"107b0f1d","345":"3410a212","353":"4ae51a0f","543":"cba53be9","594":"62213cd9","609":"25f1125a"}[chunkId] + ".css";
};